<template>
	<div v-if="size" class="row dynvibeRow" style="margin-top: 0px">
		<div class="col-lg-12">
			<select id="dynvibeSelectSize" class="form-control dynvibeSelect select" name="items" v-model="range" @change="clickOnRange">
				<option value selected>Posts per page</option>
				<option value="20">20</option>
				<option value="50">50</option>
				<option value="100">100</option>
				<option value="500">500</option>
			</select>
			<select
				v-if="sortable"
				id="dynvibeListSort"
				class="listSort dynvibeListSort dynvibeSelect sort"
				name="orderBy"
				@change="clickOnSort"
				v-model="orderBy"
			>
				<option value="latest_published">Latest published</option>
				<option value="oldest_published">Oldest published</option>
				<option value="authors">Profiles</option>
			</select>
		</div>
	</div>
	<div v-else class="col-xs-5" style="float: right">
		<select class="form-control dynvibeSelect dynvibeRangeStoryListDetails select" name="items" v-model="range" @change="clickOnRange">
			<option>Posts per page</option>
			<option value="20" selected>20</option>
			<option value="50">50</option>
			<option value="100">100</option>
			<option value="500">500</option>
		</select>
		<select
			v-if="sortable"
			class="form-control dynvibeSelect dynvibeSortStoryListDetails sort"
			name="orderBy"
			@change="clickOnSort"
			v-model="orderBy"
		>
			<option value="latest_published">Latest published</option>
			<option value="oldest_published">Oldest published</option>
			<option value="authors">Profiles</option>
		</select>
	</div>
</template>
<script>
export default {
	name: "perpageSort",
	emits: ["changesort", "changerange"],
	props: {
		size: {
			type: Boolean,
			default: true,
		},
		sortable: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			range: 20,
			orderBy: "latest_published",
		};
	},
	mounted() {},
	methods: {
		clickOnSort() {
			this.$emit("changesort", this.orderBy);
		},
		clickOnRange() {
			this.$emit("changerange", this.range);
		},
	},
};
</script>
<style>
.sort {
	color: #23056b;
	background-color: #e4e1ec;
	margin-left: 10px;
}

.select {
	color: #ef402e;
	background-color: #f9e7e6;
}
</style>
